import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API_URL, Project, ProjectInfo, ProjectInfoRaw } from '@frontend-site/shared/data';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { ProjectStore } from './project.store';

const PQM = '/pqm';

@Injectable({ providedIn: 'root' })
export class ProjectService {
    constructor(
        @Inject(API_URL) private readonly apiUrl: string,
        private readonly http: HttpClient,
        private readonly projectStore: ProjectStore
    ) {}

    loadProjects(): Observable<Project[]> {
        return this.getProjects().pipe(
            tap((result) => {
                this.projectStore.setProjects(result);
            }),
            catchError((err) => {
                console.log('failed loading projects', err);
                return throwError(() => err);
            })
        );
    }

    loadProjectDetails(projectId: number): Observable<ProjectInfo> {
        return this.getProjectDetails(projectId).pipe(
            tap((projectInfo) => {
                this.projectStore.updateSelectedProjectDetails(projectInfo);
            })
        );
    }

    getActiveProjects(): Observable<Project[]> {
        return this.getProjects().pipe(
            map((projects: Project[]) => projects.filter((project: Project) => (project.projectStatus = 'ACTIVE')))
        );
    }

    private getProjects(): Observable<Project[]> {
        return this.http.get<Project[]>(`${this.apiUrl}${PQM}/`);
    }

    private getProjectDetails(projectId: number): Observable<ProjectInfo> {
        const params = new HttpParams().set('projectId', projectId);
        return this.http
            .get<ProjectInfoRaw>(`${this.apiUrl}${PQM}/projectInformation`, { params })
            .pipe(map((data) => new ProjectInfo(data)));
    }
}
